export default __webpack_public_path__ + "static/media/map.b5f63657.png";